// Error messages translations
export const errorsTranslations = {
  en: {
    "general": {
      "somethingWrong": "Something went wrong",
      "tryAgain": "Please try again",
      "invalidRequest": "Invalid request",
      "unauthorized": "Unauthorized access",
      "notFound": "Not found",
      "serverError": "Server error"
    },
    "form": {
      "required": "This field is required",
      "invalid": "Invalid input",
      "tooShort": "Input is too short",
      "tooLong": "Input is too long",
      "invalidEmail": "Invalid email address",
      "passwordMismatch": "Passwords do not match"
    },
    "api": {
      "connectionError": "Connection error",
      "timeout": "Request timed out",
      "invalidResponse": "Invalid server response"
    }
  },
  zh: {
    "general": {
      "somethingWrong": "出错了",
      "tryAgain": "请重试",
      "invalidRequest": "无效的请求",
      "unauthorized": "未授权访问",
      "notFound": "未找到",
      "serverError": "服务器错误"
    },
    "form": {
      "required": "此字段为必填",
      "invalid": "无效的输入",
      "tooShort": "输入太短",
      "tooLong": "输入太长",
      "invalidEmail": "无效的电子邮箱地址",
      "passwordMismatch": "密码不匹配"
    },
    "api": {
      "connectionError": "连接错误",
      "timeout": "请求超时",
      "invalidResponse": "服务器响应无效"
    }
  },
  fr: {
    "general": {
      "somethingWrong": "Une erreur s'est produite",
      "tryAgain": "Veuillez réessayer",
      "invalidRequest": "Requête invalide",
      "unauthorized": "Accès non autorisé",
      "notFound": "Non trouvé",
      "serverError": "Erreur du serveur"
    },
    "form": {
      "required": "Ce champ est requis",
      "invalid": "Entrée invalide",
      "tooShort": "L'entrée est trop courte",
      "tooLong": "L'entrée est trop longue",
      "invalidEmail": "Adresse e-mail invalide",
      "passwordMismatch": "Les mots de passe ne correspondent pas"
    },
    "api": {
      "connectionError": "Erreur de connexion",
      "timeout": "Délai d'attente dépassé",
      "invalidResponse": "Réponse invalide du serveur"
    }
  },
  nb: {
    "general": {
      "somethingWrong": "Noe gikk galt",
      "tryAgain": "Vennligst prøv igjen",
      "invalidRequest": "Ugyldig forespørsel",
      "unauthorized": "Uautorisert tilgang",
      "notFound": "Ikke funnet",
      "serverError": "Serverfeil"
    },
    "form": {
      "required": "Dette feltet er påkrevd",
      "invalid": "Ugyldig inndata",
      "tooShort": "For kort inndata",
      "tooLong": "For lang inndata",
      "invalidEmail": "Ugyldig e-postadresse",
      "passwordMismatch": "Passordene stemmer ikke overens"
    },
    "api": {
      "connectionError": "Tilkoblingsfeil",
      "timeout": "Tidsavbrudd",
      "invalidResponse": "Ugyldig svar fra server"
    }
  },
  nl: {
    "general": {
      "somethingWrong": "Er ging iets mis",
      "tryAgain": "Probeer het opnieuw",
      "invalidRequest": "Ongeldig verzoek",
      "unauthorized": "Ongeautoriseerde toegang",
      "notFound": "Niet gevonden",
      "serverError": "Serverfout"
    },
    "form": {
      "required": "Dit veld is verplicht",
      "invalid": "Ongeldige invoer",
      "tooShort": "Invoer is te kort",
      "tooLong": "Invoer is te lang",
      "invalidEmail": "Ongeldig e-mailadres",
      "passwordMismatch": "Wachtwoorden komen niet overeen"
    },
    "api": {
      "connectionError": "Verbindingsfout",
      "timeout": "Verzoek time-out",
      "invalidResponse": "Ongeldig serverantwoord"
    }
  },
  de: {
    "general": {
      "somethingWrong": "Etwas ist schiefgelaufen",
      "tryAgain": "Bitte versuchen Sie es erneut",
      "invalidRequest": "Ungültige Anfrage",
      "unauthorized": "Nicht autorisierter Zugriff",
      "notFound": "Nicht gefunden",
      "serverError": "Serverfehler"
    },
    "form": {
      "required": "Dieses Feld ist erforderlich",
      "invalid": "Ungültige Eingabe",
      "tooShort": "Eingabe ist zu kurz",
      "tooLong": "Eingabe ist zu lang",
      "invalidEmail": "Ungültige E-Mail-Adresse",
      "passwordMismatch": "Passwörter stimmen nicht überein"
    },
    "api": {
      "connectionError": "Verbindungsfehler",
      "timeout": "Anfrage-Zeitüberschreitung",
      "invalidResponse": "Ungültige Serverantwort"
    }
  },
  es: {
    "general": {
      "somethingWrong": "Algo salió mal",
      "tryAgain": "Por favor, inténtelo de nuevo",
      "invalidRequest": "Solicitud no válida",
      "unauthorized": "Acceso no autorizado",
      "notFound": "No encontrado",
      "serverError": "Error del servidor"
    },
    "form": {
      "required": "Este campo es obligatorio",
      "invalid": "Entrada no válida",
      "tooShort": "La entrada es demasiado corta",
      "tooLong": "La entrada es demasiado larga",
      "invalidEmail": "Dirección de correo electrónico no válida",
      "passwordMismatch": "Las contraseñas no coinciden"
    },
    "api": {
      "connectionError": "Error de conexión",
      "timeout": "Tiempo de espera agotado",
      "invalidResponse": "Respuesta del servidor no válida"
    }
  },
  pt: {
    "general": {
      "somethingWrong": "Algo correu mal",
      "tryAgain": "Por favor, tente novamente",
      "invalidRequest": "Pedido inválido",
      "unauthorized": "Acesso não autorizado",
      "notFound": "Não encontrado",
      "serverError": "Erro do servidor"
    },
    "form": {
      "required": "Este campo é obrigatório",
      "invalid": "Entrada inválida",
      "tooShort": "A entrada é muito curta",
      "tooLong": "A entrada é muito longa",
      "invalidEmail": "Endereço de e-mail inválido",
      "passwordMismatch": "As senhas não coincidem"
    },
    "api": {
      "connectionError": "Erro de conexão",
      "timeout": "Tempo limite da solicitação esgotado",
      "invalidResponse": "Resposta inválida do servidor"
    }
  },
  ja: {
    "general": {
      "somethingWrong": "エラーが発生しました",
      "tryAgain": "もう一度お試しください",
      "invalidRequest": "無効なリクエスト",
      "unauthorized": "不正アクセス",
      "notFound": "見つかりません",
      "serverError": "サーバーエラー"
    },
    "form": {
      "required": "このフィールドは必須です",
      "invalid": "無効な入力",
      "tooShort": "入力が短すぎます",
      "tooLong": "入力が長すぎます",
      "invalidEmail": "無効なメールアドレス",
      "passwordMismatch": "パスワードが一致しません"
    },
    "api": {
      "connectionError": "接続エラー",
      "timeout": "リクエストがタイムアウトしました",
      "invalidResponse": "無効なサーバーレスポンス"
    }
  },
  ar: {
    "general": {
      "somethingWrong": "حدث خطأ ما",
      "tryAgain": "يرجى المحاولة مرة أخرى",
      "invalidRequest": "طلب غير صالح",
      "unauthorized": "وصول غير مصرح به",
      "notFound": "غير موجود",
      "serverError": "خطأ في الخادم"
    },
    "form": {
      "required": "هذا الحقل مطلوب",
      "invalid": "إدخال غير صالح",
      "tooShort": "الإدخال قصير جداً",
      "tooLong": "الإدخال طويل جداً",
      "invalidEmail": "عنوان البريد الإلكتروني غير صالح",
      "passwordMismatch": "كلمات المرور غير متطابقة"
    },
    "api": {
      "connectionError": "خطأ في الاتصال",
      "timeout": "انتهت مهلة الطلب",
      "invalidResponse": "استجابة خادم غير صالحة"
    }
  }
};
